import React, { useEffect, useState } from 'react'
import { LIMIT_ALL } from '../../../../../../constants/pagination'
import { filterActiveOptions } from '../../../../../../utils/app.utils'
import { useTranslation } from 'react-i18next'
import { MenuItem, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

// COMPONENT
import InputTextField from '../../../../../../component/input/inputTextField';
import FilterSelect from '../../../../../../component/select/filterSelect';
import { ButtonContained } from '../../../../../../component/mui-custom/MuiCustom';
import { setLoading, unsetLoading } from '../../../../../../store/slice/loading/loading.slice';

// API
import { StrategyApi, createStrategy } from '../../../../../../api/strategy/strategy.api';
import { FiscalYearApi } from '../../../../../../api/fiscal-year/fiscalyear.api';
import { swalError, swalSuccess } from '../../../../../../component/notification/swal';

type Props = {
    fetchData: () => void;
    toggleModal: () => void;
    idStrategyRef: number;
}

const AddStrategy: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();

    const idFiscalYear = useSelector((state: any) => state?.fiscalYear?.idFiscalYear)

    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [strategy, setStrategy] = useState<createStrategy>({
        strategyNo: "",
        strategyName: "",
        strategyDesc: "",
        strategyStatus: t("STATUS.ACTIVE"),
        idFiscalYear: location.pathname.includes(idFiscalYear) ? idFiscalYear : 0,
        idStrategyRef: props.idStrategyRef,
    })

    const handleGetFiscalYear = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setFiscalYear(res.data?.result?.items)
                    if (res?.data?.result?.items?.length > 0) {
                        setStrategy((prev) => ({ ...prev, idFiscalYear: idFiscalYear === 0 ? (filterActiveOptions(res.data?.result?.items, 'fiscalYearStatus', 'idFiscalYear')[0] || res.data?.result?.items[0])?.idFiscalYear : idFiscalYear }))
                    }
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }

    const handleSubmit = async (event: React.FormEvent) => {
        dispatch(setLoading())
        event.preventDefault();
        await StrategyApi.createStrategy(strategy)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                    props.toggleModal()
                    props.fetchData()
                } else {
                    swalError(res.response?.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalError(error.response?.data?.description)
                console.log(error)
            })
    }

    useEffect(() => {
        handleGetFiscalYear()
    }, [])
    return (
        <form className='w-full' onSubmit={handleSubmit}>
            <div className='flex flex-col w-full mt-8 gap-5'>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setStrategy((prev) => ({ ...prev, strategyNo: e.target.value }))}
                        value={strategy.strategyNo}
                        heading='ลำดับยุทธศาสตร์'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setStrategy((prev) => ({ ...prev, strategyName: e.target.value }))}
                        value={strategy.strategyName}
                        heading='ชื่อยุทธศาสตร์'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setStrategy((prev) => ({ ...prev, strategyDesc: e.target.value }))}
                        value={strategy.strategyDesc}
                        heading='คำขยายความยุทธศาสตร์'
                    />
                </span>
                <span>
                    <FilterSelect
                        disabled={idFiscalYear !== 0}
                        required
                        renderValue={() => fiscalYear.find((list: any) => list?.idFiscalYear === strategy.idFiscalYear)?.fiscalYear}
                        heading={t("ปีงบประมาณ")}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={strategy.idFiscalYear}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setStrategy((prev) => ({ ...prev, idFiscalYear: Number(event.target.value) }))}
                        options={filterActiveOptions(fiscalYear, 'fiscalYearStatus', 'idFiscalYear', [strategy.idFiscalYear]).map((list: any) => (
                            <MenuItem disabled={list?.fiscalYearStatus === false} key={list?.idFiscalYear} value={list?.idFiscalYear}>
                                <Typography>
                                    {list?.fiscalYear}
                                </Typography>
                            </MenuItem>
                        ))}
                    />
                </span>
                <span>
                    <FilterSelect
                        required
                        heading={t("สถานะ")}
                        renderValue={() => strategy.strategyStatus === t("STATUS.ACTIVE") ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={strategy.strategyStatus}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setStrategy((prev) => ({ ...prev, strategyStatus: event.target.value }))}
                        options={[
                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='mt-3 flex justify-center items-center'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 105 }}
                    >
                        {t("BUTTON.SUBMIT")}
                    </ButtonContained>
                </span>
            </div>
        </form>
    )
}

export default AddStrategy

